import { createFileRoute } from '@tanstack/react-router'
import { fetchDevices } from '../../admin/server-fns'
import {
  SAMPLE_LIMIT,
  SampleNote,
  VersionDistribution,
  groupDevices,
} from '../../admin/aggregate'
import { AdminRouteError, PageHeader } from '../../admin/ui'

export const Route = createFileRoute('/admin/configs')({
  loader: async () => fetchDevices({ data: { page: 1, limit: SAMPLE_LIMIT } }),
  component: Configs,
  errorComponent: AdminRouteError,
})

function Configs() {
  const data = Route.useLoaderData()
  const groups = groupDevices(data.items, (d) => `v${d.configVersion}`)

  return (
    <>
      <PageHeader kicker="Operations" title="Configs" />
      <p className="mb-4 mt-0 max-w-xl text-sm text-slate-600 dark:text-slate-400">
        Config versions currently running across the fleet. Send CONFIG_UPDATE from a device's
        detail page to move it to a new version.
      </p>
      <SampleNote total={data.total} sampled={data.items.length} />
      <VersionDistribution label="Config version" groups={groups} total={data.items.length} />
    </>
  )
}
